import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { InformationComponent } from '../../core/information/information.component';
import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { TemplateService } from '../../services/template.service';
import { DownloadLogComponent } from '../download-log/download-log.component';
var RDSendReportComponent = (function () {
    function RDSendReportComponent(apiService, modalService, authService, template, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.authService = authService;
        this.template = template;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.allBranch = true;
        this.allDocType = true;
        this.selectedValues = [];
        this.currentPage = 1;
        this.loading = false;
        this.no_data = true;
        this.value = 0;
        this.sum_docs_count = 0;
        this.errorMsg = '';
        this.resendAllPendingMessage = '';
        this.monthListDropdown = [
            { label: 'มกราคม', value: 1 },
            { label: 'กุมภาพันธ์', value: 2 },
            { label: 'มีนาคม', value: 3 },
            { label: 'เมษายน', value: 4 },
            { label: 'พฤษภาคม', value: 5 },
            { label: 'มิถุนายน', value: 6 },
            { label: 'กรกฎาคม', value: 7 },
            { label: 'สิงหาคม', value: 8 },
            { label: 'กันยายน', value: 9 },
            { label: 'ตุลาคม', value: 10 },
            { label: 'พฤศจิกายน', value: 11 },
            { label: 'ธันวาคม', value: 12 }
        ];
        this.yearList = [];
        this.index = 0;
        this.branchList = null;
        this.allBranchList = null;
        this.is_TH = false;
        this.rdStatusDropdown = [];
        this.tableCol = [];
        this.filterAcceptedSelected = false;
        this.filterRejectedSelected = false;
        this.filterPendingSelected = false;
        this.loading_excel_report = false;
    }
    RDSendReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.populateDropdown();
        });
        this.populateDropdown();
        this.searchData();
    };
    Object.defineProperty(RDSendReportComponent.prototype, "currentLang", {
        get: function () {
            return this.translate.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    RDSendReportComponent.prototype.populateDropdown = function () {
        this.loadCompanyAndBranch();
        this.loadDocumentType();
        this.loadRDStatus();
        this.loadTableHeader();
        this.loadMonthYear();
    };
    RDSendReportComponent.prototype.loadMonthYear = function () {
        this.monthListDropdown = [
            { label: this.translate.instant('MONTH.JANUARY'), value: 1 },
            { label: this.translate.instant('MONTH.FEBRUARY'), value: 2 },
            { label: this.translate.instant('MONTH.MARCH'), value: 3 },
            { label: this.translate.instant('MONTH.APRIL'), value: 4 },
            { label: this.translate.instant('MONTH.MAY'), value: 5 },
            { label: this.translate.instant('MONTH.JUNE'), value: 6 },
            { label: this.translate.instant('MONTH.JULY'), value: 7 },
            { label: this.translate.instant('MONTH.AUGUST'), value: 8 },
            { label: this.translate.instant('MONTH.SEPTEMBER'), value: 9 },
            { label: this.translate.instant('MONTH.OCTOBER'), value: 10 },
            { label: this.translate.instant('MONTH.NOVEMBER'), value: 11 },
            { label: this.translate.instant('MONTH.DECEMBER'), value: 12 }
        ];
        var currentDate = new Date();
        // populate year list back within 10 years
        var thisYear = currentDate.getFullYear();
        for (var i = 0; i <= 10; i++) {
            this.yearList.push({ label: (thisYear - i).toString(), value: thisYear - i });
        }
        // set current month and year
        this.selectedMonth = currentDate.getMonth() + 1;
        this.selectedYear = thisYear;
    };
    RDSendReportComponent.prototype.loadDocumentType = function () {
        var documentData = this.template.getDropdown();
        documentData[0] = { label: this.translate.instant('COMMON.ALL'), value: null };
        this.rdDocumentType = documentData;
        this.selectedRdDocumentType = null;
    };
    RDSendReportComponent.prototype.loadTableHeader = function () {
        this.tableCol = [
            { field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME') },
            { field: 'rd_document_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE') },
            { field: 'identifier', header: this.translate.instant('TABLE.DOCUMENT-NUMBER') },
            { field: 'header_issue_dt', header: this.translate.instant('RD-SEND-REPORT.ISSUE-DATE') },
            { field: 'created_at', header: this.translate.instant('RD-SEND-REPORT.SEND-DATE') },
            { field: 'conversation_id', header: this.translate.instant('RD-SEND-REPORT.CONVERSATION-ID') },
            { field: 'sent_to_rd', header: this.translate.instant('RD-SEND-REPORT.SENT-TO-SP') },
            { field: 'rd_acknowledged', header: this.translate.instant('RD-SEND-REPORT.RD-ACKNOWLEDGED') },
            { field: 'rd_status', header: this.translate.instant('RD-SEND-REPORT.RESULT.STATUS') },
        ];
    };
    RDSendReportComponent.prototype.loadCompanyAndBranch = function () {
        var _this = this;
        this.company = [];
        this.apiService.getCompany().subscribe(function (result) {
            _this.company = [{
                    label: _this.translate.instant('COMMON.ALL'),
                    value: null
                }];
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
            _this.selectedCompany = null;
        });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
    };
    RDSendReportComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate === _this.selectedCompany) {
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
            }
        });
    };
    RDSendReportComponent.prototype.loadRDStatus = function () {
        this.rdStatusDropdown = [
            {
                label: this.translate.instant('COMMON.ALL'),
                value: null,
            },
            {
                label: this.translate.instant('RD-SEND-REPORT.RESULT.PENDING'),
                value: 'pending',
            },
            {
                label: this.translate.instant('RD-SEND-REPORT.RESULT.REJECTED'),
                value: 'rd_rejected',
            },
            {
                label: this.translate.instant('RD-SEND-REPORT.RESULT.ACCEPTED'),
                value: 'rd_accepted',
            },
        ];
        this.selectedStatus = null;
    };
    RDSendReportComponent.prototype.pageChanged = function () {
        this.searchData();
    };
    RDSendReportComponent.prototype.searchData = function () {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        var params = {
            month: this.selectedMonth || '',
            year: this.selectedYear || '',
            company_id: this.selectedCompany || '',
            branch_id: this.selectedBranch ? this.selectedBranch : '',
            items_per_page: this.itemsPerPage,
            rd_doc_type: this.selectedRdDocumentType || '',
            status: this.selectedStatus || '',
        };
        if (this.currentPage > 1) {
            params['page'] = this.currentPage;
        }
        if (this.sortBy) {
            params['ordering'] = this.sortMode + this.sortBy;
        }
        this.apiService.getRDSendReport(params).subscribe(function (result) {
            // Check if result object is empty
            if (Object.keys(result).length != 0 || result.constructor != Object) {
                _this.loading = false;
                _this.tableData = result.results;
                _this.tableDataDisplay = _this.tableData;
                _this.no_data = _.isEmpty(_this.tableData);
                _this.totalItems = result.count;
                _this.statistic = result.statistic;
                _this.selectedValues = [];
                for (var i = 0; i < _this.tableData.length; i++) {
                    _this.selectedValues.push(false);
                }
            }
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
        this.getLatestManualResendTime();
    };
    RDSendReportComponent.prototype.downloadReport = function () {
        var _this = this;
        this.loading_excel_report = true;
        var params = {
            month: this.selectedMonth || '',
            year: this.selectedYear || '',
            company_id: this.selectedCompany || '',
            branch_id: this.selectedBranch ? this.selectedBranch : '',
            rd_doc_type: this.selectedRdDocumentType || '',
            status: this.selectedStatus || '',
        };
        if (this.sortBy) {
            params['ordering'] = this.sortMode + this.sortBy;
        }
        this.apiService.downloadRDSendReport(params).subscribe(function () {
            _this.loading_excel_report = false;
            _this.informUser(_this.translate.instant('COMMON.ADDED-TO-QUEUE'));
        }, function (error) {
            _this.loading_excel_report = false;
            _this.informUser();
        });
    };
    RDSendReportComponent.prototype.informUser = function (message) {
        var modal = this.modalService.open(InformationComponent, { centered: true });
        modal.componentInstance.message = message || this.translate.instant('ERROR.TRY-AGAIN');
    };
    RDSendReportComponent.prototype.showDownloadLogs = function () {
        var modal = this.modalService.open(DownloadLogComponent, { size: 'lg' });
        modal.componentInstance.feature = 'rd_summary';
    };
    RDSendReportComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.searchData();
    };
    RDSendReportComponent.prototype.getLatestManualResendTime = function () {
        var _this = this;
        var data = {
            month: this.selectedMonth,
            year: this.selectedYear,
        };
        this.apiService.getLatestManualResendTime(data).subscribe(function (result) {
            _this.canManualResend = result.can_manual_resend;
        }, function (error) {
            console.log('error', error);
        });
    };
    RDSendReportComponent.prototype.closeResendAllPending = function () {
        this.modal.close();
        this.searchButtonClicked();
    };
    RDSendReportComponent.prototype.resendAllPending = function (content) {
        var _this = this;
        var data = {
            month: this.selectedMonth,
            year: this.selectedYear,
        };
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
        this.apiService.resendAllPendingEbxml(data).subscribe(function (res) {
            _this.resendAllPendingMessage = res.msg;
        }, function (error) {
            console.log(error);
        });
    };
    RDSendReportComponent.prototype.clearData = function () {
        var currentDate = new Date();
        this.selectedMonth = currentDate.getMonth() + 1;
        this.selectedYear = currentDate.getFullYear();
        this.selectedCompany = null;
        this.selectedVerifiedAccount = null;
        this.branch = null;
        this.documentType = null;
        this.allDocType = true;
        this.allBranch = true;
        this.selectedBranch = null;
        this.selectedRdDocumentType = null;
        this.selectedStatus = null;
        this.searchButtonClicked();
    };
    RDSendReportComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.branch) && this.allBranch === false) {
            errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' +
                this.translate.instant('COMMON.CORRECT');
        }
    };
    RDSendReportComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = '';
        }
        else {
            this.sortMode = '-';
        }
    };
    // resend function is not used now
    RDSendReportComponent.prototype.resend = function (taxDataId) {
        var _this = this;
        this.apiService.resendToRD(taxDataId).subscribe(function (res) {
            _this.searchData();
        }, function (error) {
            console.log(error);
        });
    };
    RDSendReportComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return RDSendReportComponent;
}());
export { RDSendReportComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/rd-send-report/rd-send-report.component.ts.pre-build-optimizer.js